import { useEffect, useState } from "react";
import { useLanguageApp } from "../../ui/src/context/LanguageContext";
import { LanguagesJson } from "../Idiomas";

export const useLanguage = () =>{

const {currentLanguage, setCurrentLanguage} = useLanguageApp();

const [language, setLanguage] = useState(currentLanguage);
const [translation, setTranslation] = useState(LanguagesJson[currentLanguage]);

useEffect(()=>{setLanguage(currentLanguage)},[currentLanguage])

useEffect(()=>{
    setTranslation(LanguagesJson[language]);
},[language])

const languages = [{value:'ES',label:'Castellano'},{value:'GB', label:'English'}]

const onChnageLanguage = (language:string) => {setCurrentLanguage(language)}

const translate = (key:string) => translation[key] === undefined ? 'error' : translation[key];

return {languages,onChnageLanguage, language, translate}

}